module.exports = __webpack_public_path__ + "img/Reviews and Ratings.1c5a66fc.svg";